import { createAction } from '@reduxjs/toolkit';

export const STORE_RESET_ACTION_TYPE = 'store-reset/action';

export const resetStore = createAction(STORE_RESET_ACTION_TYPE);